module.exports = __webpack_public_path__ + "img/1749007657_bzMz.507c2c01.jpg";